// Angular
import { Component, OnInit, OnDestroy } from '@angular/core';

// Data/Class/Interface/Others
import Tabulator from 'tabulator-tables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { WHAT } from 'src/app/shared/classes';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessagesService } from 'src/app/services/message/messages.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { BaseModalComponent } from 'src/app/shared/modals/base-modal/base-modal.component';
import { EventsService } from 'src/app/services/events/events.service';
import { VoucherDeleteComponent } from 'src/app/shared/modals/voucher-delete/voucher-delete.component';
import { VoucherCreateComponent } from 'src/app/shared/modals/voucher-create/voucher-create.component';
import { VoucherRedeemedComponent } from 'src/app/shared/voucher-redeemed/voucher-redeemed.component';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.less']
})
export class VouchersComponent implements OnInit, OnDestroy {
  private table: Tabulator;

  private todaysDate = new Date().toISOString();
  private allUsers = [];
  private filterStateObj = {
    currentFilter: '',
    currentData: [],
    allData: []
  };

  public listOfVouchersForRemoval = [];

  public subscribtionYears = [];

  constructor(private ngbModal: NgbModal, private admin: AdminService, private load: NgxSpinnerService, private msg: MessagesService,
    private utils: UtilsService, private events: EventsService) { }

  ngOnInit() {
    this.load.show();
    this.initTable();
    this.getAllUsers();
    this.getAllVouchers();
    this.listenToLoadTable();
  }

  ngOnDestroy() {
    
  }

  // listens to true values so that table can be reloaded with page reload
  private listenToLoadTable() {
    this.events.getTableTriggers()
      .subscribe(triggers => {
        const from = triggers.from;
        switch (triggers.task) {
          case 'create':
            this.load.show();
            this.getAllVouchers();
            break;

          case 'update':
            if (from === 'vouchers') {
              if (triggers.tableReload) {
                const userid = triggers.userid;
                const userData = triggers.userData as any;
                const discount = userData.discount;
                const count = userData.count;
                const description = JSON.parse(userData.description);
                const extendYear = description.extendYear;
                const isTraining = description.isTraining;
                const voucherStatus = userData.status;
                const category = userData.category;
                const duration = description.duration;
                const subscription_type = description.subscription_type;
                const account_type = description.account_type;

                this.table.updateData([{
                  id: userid, discount: discount, count: count,
                  duration:duration,subscription_type:subscription_type, status: voucherStatus, category: category, isTraining: isTraining,
                  account_type:account_type
                }])
                  .then(() => {
                    // update table data state
                    this.filterStateObj.allData = this.table.getData();
                    // run code after data has been updated
                  })
                  .catch((error) => {
                    // handle error updating data
                    this.load.hide();
                  });
              }
            }

            break;
          case 'delete':
            if (from === 'vouchers') {
              if (triggers.tableReload) {
                const userid = triggers.userid;
                this.table.deleteRow(userid)
                  .then(() => {
                    // update table data state
                    this.filterStateObj.allData = this.table.getData();

                    // run code after data has been updated
                    this.load.hide();
                  })
                  .catch((error) => {
                    // handle error updating data
                    this.load.hide();
                  });
              }
            }
            break;

          case 'delete-array':
            if (from === 'vouchers') {
              if (triggers.tableReload) {
                const userid = triggers.userid;
                this.table.deleteRow(userid)
                  .then(() => {
                    // update table data state
                    this.filterStateObj.allData = this.table.getData();

                    this.listOfVouchersForRemoval = [];
                  })
                  .catch((error) => {
                    // handle error updating data
                    this.load.hide();
                  });
              }
            }
            break;
        }
      }, error => {
        console.log(error);
      });
  }

  // create voucher
  public createVoucher() {
    this.ngbModal.open(VoucherCreateComponent, {
      size: 'lg'
    });
  }

  public async showAllRedeemed() {
    const allVoucher = await this.admin.GET(WHAT.Vouchers);
    const modalInst = this.ngbModal.open(VoucherRedeemedComponent, {
      size: 'lg',
      windowClass: 'hugeModal'
    });


    modalInst.componentInstance.allUsers = this.allUsers;
    modalInst.componentInstance.allVouchers = allVoucher;
  }

  // adds voucher to remove array
  private returnCheckBox(cell, formatterParams) {
    const id = cell._cell.row.data.id;
    const checkBox = document.createElement('input');
    checkBox.setAttribute('type', 'checkbox');

    for (const theId of this.listOfVouchersForRemoval) {
      const rowId = cell._cell.row.data.id;

      if (theId === rowId) {
        checkBox.checked = true;
      }
    }

    checkBox.addEventListener('change', e => this.addToRemoval(e, id));
    return checkBox;
  }

  // add or remove voucher from removal
  public addToRemoval(e, id) {
    e.stopPropagation();
    e.preventDefault();

    // add to global component removal array
    if (this.listOfVouchersForRemoval.indexOf(id) === -1) {
      this.listOfVouchersForRemoval.push(id);
    } else {
      this.listOfVouchersForRemoval.splice(this.listOfVouchersForRemoval.indexOf(id), 1);
    }
  }

  // calls the delete modal
  public removeSelectedVouchers() {
    const modal = this.ngbModal.open(VoucherDeleteComponent, {
      size: 'lg'
    });

    const voucherObj = {
      from: 'vouchers',
      data: this.listOfVouchersForRemoval
    };

    modal.componentInstance.voucherDetails = voucherObj;
  }

  // inits the table
  private initTable() {
    this.table = new Tabulator('#voucherTable', {
      responsiveLayout: 'collapse',
      pagination: 'local',
      paginationSize: 15,
      paginationSizeSelector: true,
      index: 'id',
      layout: 'fitColumns',
      columns: [
        {
          title: 'Select', width: 80, headerSort: false, formatter: this.returnCheckBox.bind(this), cellClick: function (e, cell) {
            e.stopPropagation();
          }, headerClick: (e, column) => {
            const rows = this.table.rowManager.rows;
            for (const row of rows) {
              const selectCell = row.cells[0];

              const id = row.data.id;
              this.addToRemoval(e, id);

              if (selectCell) {
                const checkBox = selectCell.element.firstChild;
                checkBox.checked = !checkBox.checked;
              }
            }
          }
        },
        {title: 'Status', field: 'status', width: 100, sorter: 'string' },
        {title: 'Category', field: 'category', width: 100, sorter: 'string' },
        {title: 'Code', field: 'code', width: 100, sorter: 'string' },
        {title: 'Discount', field: 'discount', width: 100, sorter: 'number'},
        {title: 'Account Type', field: 'account_type', width: 100, sorter: 'string'},
        {title: 'Plan Type', field: 'plan_type', width: 100, sorter: 'string'},
        // {title: 'Duration', field: 'duration', width: 100, sorter: 'number'},
        // {title:'Subscription Type', field:'subscription_type', width: 100, sorter: 'string'},
        {title: 'Is Training Voucher', field: 'isTraining', width: 100, sorter: 'string' },
        {title: 'Voucher Id', field: 'id', sorter: 'string', visible: false },
        {
          title: 'Created On', field: 'date', sorter:'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
          }
        },
        {
          title: 'Expires On', field: 'expired', sorter: 'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
          }
        },
        {title: 'Total Vouchers', field: 'totalCount', width: 100, sorter:'number'},
        {title: 'Redeemed', field: 'count', width: 100, sorter:'number'}
      ],
      rowClick: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'vouchers',
          data: data
        };

        // mouse click event
        this.loadModal(newData);
      },
      rowTap: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'voucher',
          data: data
        };

        // touch screen tap
        this.loadModal(newData);
      }
    });
  }

  // get all users for voucher user reference check
  private getAllUsers() {
    this.admin.GET(WHAT.Users)
      .then(res => {
        this.allUsers = res;
      })
      .catch((error) => this.error(error));
  }

  // filter vouchers
  public filterTheVoucherSection(options) {
    this.table.clearFilter();
    this.table.replaceData(this.filterStateObj.allData);

    switch (options) {
      case 'valid':
        this.filterVoucher(this.todaysDate);
        this.table.addFilter(this.filterStateObj.currentFilter);
        break;

      case 'claimed':
        this.table.setFilter('count', '=', '0');
        this.table.addFilter(this.filterStateObj.currentFilter);
        break;

      case 'promotion':
      case 'individual':
        this.table.setFilter('category', '=', options);
        break;

      default:
        break;
    }
  }

  // filters voucher
  private filterVoucher(searchVal) {
    this.table.setFilter((data, filterParams) => {

      const todaysDate = this.utils.returnDate(filterParams.param, 'moment');
      const vouchDate = this.utils.returnDate(data.expired, 'moment');

      return vouchDate >= todaysDate;

    }, { param: searchVal });
  }

  // filter by extend year
  public filterDuration(duration) {
    if (duration !== 'all') {
      this.table.setFilter((data, filterParams) => {
        const duration = filterParams.params;

        return data.duration === duration;

      }, { params: duration });
    } else {
      this.table.clearFilter();
      this.table.replaceData(this.filterStateObj.allData);
    }
  }

  // filter is training
  public filterIsTraining(value) {
    this.table.setFilter((data, filterParams) => {
      const isTraining = filterParams.params === 'true' ? true : false;

      return data.isTraining === isTraining;

    }, { params: value });
  this.filterStateObj.currentFilter = this.table.getFilters();
  }

  public filterSubscriptionType(value) {
    if(value != 'all'){
      this.table.setFilter((data, filterParams) => {
        const subscription_type = filterParams.params === 'yearly' ? 'yearly' : 'monthly';
  
        return data.subscription_type === subscription_type;
  
      }, { params: value });
      this.filterStateObj.currentFilter = this.table.getFilters();
    }
    else{
      this.table.clearFilter();
      this.table.replaceData(this.filterStateObj.allData);
    }
  }


  // search table
  public searchTable(searchValue) {
    const filters = [];
    const columns = this.table.getColumns();

    columns.forEach(function (column) {
      filters.push({
        field: column.getField(),
        type: 'like',
        value: searchValue,
      });
    });

    this.table.setFilter([filters]);
  }

  // get all vouchers
  private getAllVouchers() {
    this.admin.GET(WHAT.Vouchers)
      .then(res => this.success(res))
      .catch(err => this.error(err));
  }

  // open modal and pass voucher data to it
  private loadModal(data) {
    const userModal = this.ngbModal.open(BaseModalComponent, {
      size: 'lg'
    });

    userModal.componentInstance.data = data;
    userModal.componentInstance.allUsers = this.allUsers;

    // userModal
    userModal.result
      .then((msg) => {
        if (msg.success) {
          return;
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // handle success
  private success(res) {
    this.table.clearData();
    this.table.addData(res);
    this.table.setSort('expired', 'desc');
    this.filterStateObj.allData = res;
    this.subscribtionYears = this.admin.getSubscriptionYears();
    this.load.hide();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }
}
